import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import SEO from '../SEO';

// A transport failure is not evidence that a catalogue entity was retired.
export const CatalogueLoadError = ({ onRetry, kind }) => {
  const initial = window.__LB_INITIAL_SEO__;
  const metadata = initial?.pathname === window.location.pathname ? initial : {
    title: `${kind.charAt(0).toUpperCase() + kind.slice(1)} | LUMIBRIGHT`,
    description: 'LUMIBRIGHT architectural lighting catalogue and project information.',
  };
  return (
  <main className="min-h-screen px-6 pt-32 pb-16" data-testid={`${kind}-load-error`}>
    <SEO {...metadata} />
    <div className="mx-auto max-w-xl" role="alert" data-testid={`${kind}-load-error-alert`}>
      <h1 className="text-4xl mb-6" data-testid={`${kind}-load-error-title`}>{kind === 'project' ? 'Project' : kind === 'system' ? 'System' : 'Catalogue'} temporarily unavailable</h1>
      <p className="mb-6 text-sm" data-testid={`${kind}-load-error-message`}>We couldn’t load this {kind} right now. Please try again.</p>
      <Button onClick={onRetry} data-testid={`${kind}-load-retry-button`}><RefreshCw className="mr-2 h-4 w-4" />Try again</Button>
    </div>
  </main>
  );
};